import { LayerSerializer } from "../../../modules/createV3/serializers/layerSerializer.ts";
import { AdTemplate } from "../AdTemplate.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class AdTemplateSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    if (data.composition_layer)
      data.composition_layer = new LayerSerializer().deserialize(
        data.composition_layer
      );
    if (data.type === "static") data.is_static = true;
    return new AdTemplate(data);
  }
}
